(function () {
  const gallery = document.querySelector("[data-about-gallery]");
  const dialog = document.querySelector("[data-about-lightbox]");
  if (!gallery || !dialog) return;

  const items = Array.from(gallery.querySelectorAll("[data-full]"));
  const img = dialog.querySelector("img");
  let index = 0;

  function openAt(i) {
    index = (i + items.length) % items.length;
    const item = items[index];
    const thumb = item.querySelector("img");
    img.src = item.getAttribute("data-full");
    img.alt = thumb ? thumb.alt : "";
    if (typeof dialog.showModal === "function") dialog.showModal();
    else dialog.setAttribute("open", "");
  }

  function close() {
    if (typeof dialog.close === "function") dialog.close();
    else dialog.removeAttribute("open");
  }

  gallery.addEventListener("click", function (event) {
    const item = event.target.closest("[data-full]");
    if (!item) return;
    openAt(items.indexOf(item));
  });

  dialog.querySelector("[data-about-close]").addEventListener("click", close);
  dialog.querySelector("[data-about-prev]").addEventListener("click", function () {
    openAt(index - 1);
  });
  dialog.querySelector("[data-about-next]").addEventListener("click", function () {
    openAt(index + 1);
  });
  dialog.addEventListener("click", function (event) {
    if (event.target === dialog) close();
  });
  document.addEventListener("keydown", function (event) {
    if (!dialog.open) return;
    if (event.key === "Escape") close();
    if (event.key === "ArrowLeft") openAt(index - 1);
    if (event.key === "ArrowRight") openAt(index + 1);
  });
})();
